var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.$route.meta.mobile)?_c('BottomNav'):_vm._e(),_c('b-loading',{attrs:{"is-full-page":true,"can-cancel":false},model:{value:(_vm.showLoading),callback:function ($$v) {_vm.showLoading=$$v},expression:"showLoading"}}),_c('offline',{on:{"detected-condition":_vm.handleConnectivityChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }